<div class="category-chips" *transloco="let t; prefix: 'products.badges'">
    @for (badge of badges; track badge) {
        <mat-chip disabled>{{ t(badge.toLowerCase()) }}</mat-chip>
    }
</div>
